import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import { useInfoStyles } from "./styles";
import { AddCircle, CalendarToday } from "@material-ui/icons";
import { UserInScheduleWithPermissions } from "../../../../../interfaces/user";
import { dateformat } from "../../../../../utils/dateFormat";
import { cpfMask } from "../../../../../utils/cpfFormat";
import AddProfileButton from "../add-profile";

type Props = {
  user: UserInScheduleWithPermissions
}

export default function UsersDetailsInfo({ user }: Props) {
  const { classes } = useInfoStyles();
  return (
    <Paper elevation={3}>
      <Box className={classes.head}>
        <Box className={classes.container}>
          <Box className={classes.header}>
            <Typography className={classes.title}>
              {user.first_name} {user.last_name}
            </Typography>
          </Box>
          <Box className={classes.infosContainer}>
            <Box className={classes.infoContainer}>
              <CalendarToday className={classes.icons} />
              <Typography className={classes.infoContainerText}>
                  Registrado: {dateformat(user?.date_joined, true) || "Não informado"}
              </Typography>
            </Box>
            <Box className={classes.infoContainer}>
              <CalendarToday className={classes.icons} />
              <Typography className={classes.infoContainerText}>
                  Último login: {dateformat(user?.last_login, true) || "Não informado"}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className={classes.headerButtonGroup}>
          <AddProfileButton
            user={user}
            buttonTrigger={
              <Button
                startIcon={<AddCircle fontSize="small" />}
                variant="contained"
                color="primary"
              >
                Adicionar perfil
              </Button>
            }
          />
        </Box>
      </Box>
      <Divider />
      <Box className={classes.content}>
        <Typography className={classes.subtitle}>
          Informações do usuário
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={6} className={classes.localInfoContainer}>
            <Typography className={classes.localInfoTitle}>CPF</Typography>
            <Typography className={classes.localInfoText}>
              {cpfMask(user.username || "")}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.localInfoContainer}>
            <Typography className={classes.localInfoTitle}>
              Órgão do usuário
            </Typography>
            <Typography className={classes.localInfoText}>
              {user.orgao_usuario?.nome || "Nenhum órgão cadastrado"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
